import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { Checkbox } from 'react-wot-bootstrap'
import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'

import {
    BATTLE_ROOMS_FILTER,
    WAITING_FOR_PLAYERS_TOOLTIP,
    HAS_FREE_SLOTS_TOOLTIP,
} from './constants.jsx'

import {
    filterByHasFreeSlots,
    filterByWaitingForPlayers,
} from 'state/actions/available_units'

import styles from './UnitCheckboxFilter.scss'

export class UnitCheckboxFilter extends React.Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        hasFreeSlotsClickHandler: PropTypes.func.isRequired,
        waitingForPlayersClickHandler: PropTypes.func.isRequired,
    }

    render() {
        const props = this.props
        return (
            <div className={styles.base}>
                <div className={styles.filterItem}>
                    <Checkbox
                        caption={BATTLE_ROOMS_FILTER.notInBattle}
                        onChange={props.waitingForPlayersClickHandler}
                        isChecked={props.filter.waitingForPlayers}
                        tooltipId={WAITING_FOR_PLAYERS_TOOLTIP.id}
                    />
                </div>
                <div className={styles.filterItem}>
                    <Checkbox
                        caption={BATTLE_ROOMS_FILTER.places}
                        onChange={props.hasFreeSlotsClickHandler}
                        isChecked={props.filter.hasFreeSlots}
                        tooltipId={HAS_FREE_SLOTS_TOOLTIP.id}
                    />
                </div>
                <DefaultTooltip {...WAITING_FOR_PLAYERS_TOOLTIP} />
                <DefaultTooltip {...HAS_FREE_SLOTS_TOOLTIP} />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    filter: state.availableUnits.filter,
})

const mapDispatchToProps = {
    hasFreeSlotsClickHandler: filterByHasFreeSlots,
    waitingForPlayersClickHandler: filterByWaitingForPlayers,
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitCheckboxFilter)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitCheckboxFilter/UnitCheckboxFilter.jsx